@let current = state();
@if (current?.phase === 'ready') {
    <qpx-quippy-pack-preview
        [preview]="current.preview"
        (editClicked)="editClicked.emit()"
        (applyClicked)="applyClicked.emit()"
    />
}
@if (current?.phase === 'applying') {
    <div class="flex items-center gap-3 p-5" role="status">
        <ng-icon qpx name="lucideFolderOpen" />
        <div>
            <p class="m-0 text-body-md font-medium">Creating your pack…</p>
            <p qpxBody="secondary" tone="muted">
                Saving the reviewed sections, requirements and documents.
            </p>
        </div>
    </div>
}
@if (current?.phase === 'uncertain') {
    <div class="grid gap-3 p-4 sm:p-5">
        <div
            class="flex items-start gap-3 rounded-lg bg-warning-muted p-3 text-warning-muted"
            role="status"
        >
            <ng-icon qpx name="lucideTriangleAlert" class="shrink-0" />
            <div>
                <p class="m-0 text-body-md font-medium">
                    Let's check the result
                </p>
                <p class="mt-1 text-body-md">
                    {{
                        current.message ||
                            'The connection was interrupted. Your changes may already be saved.'
                    }}
                </p>
            </div>
        </div>
        <p qpxBody="secondary" tone="muted">
            Open the building Packs page to check whether it was created before
            starting another proposal.
        </p>
        <button
            qpxButton
            matButton="outlined"
            (click)="openPack(current.buildingId)"
        >
            <span>Check Packs</span
            ><ng-icon qpx name="lucideArrowRight" matButtonIcon />
        </button>
    </div>
}
@if (current?.phase === 'needsReview') {
    <p
        role="alert"
        class="mx-4 mb-4 rounded-lg bg-warning-muted p-3 text-body-md text-warning-muted"
    >
        {{ current.message }}
    </p>
}
@if (current?.phase === 'applied') {
    <div class="grid gap-4 p-4 sm:p-5">
        <div class="flex items-start gap-3" role="status">
            <ng-icon
                qpx
                name="lucideCircleCheckBig"
                class="mt-1 shrink-0 text-success-decorative"
            />
            <div>
                <p class="m-0 text-body-md font-semibold">Pack created</p>
                <p qpxBody="secondary" tone="muted">
                    {{ current.pack.totalRequirementCount }}
                    {{
                        current.pack.totalRequirementCount === 1
                            ? 'requirement'
                            : 'requirements'
                    }}
                    ·
                    {{ current.pack.assignedRequirementCount }}
                    {{
                        current.pack.assignedRequirementCount === 1
                            ? 'covered requirement'
                            : 'covered requirements'
                    }}.
                </p>
            </div>
        </div>
        @if (requirementsToReview(); as requirements) {
            <div
                class="flex items-start gap-3 rounded-lg bg-warning-muted p-3 text-warning-muted"
                role="status"
            >
                <ng-icon qpx name="lucideTriangleAlert" class="shrink-0" />
                <div>
                    <p class="m-0 text-body-md font-medium">
                        Some selected documents could not be attached.
                    </p>
                    <p class="mt-1 text-body-md">
                        Your sections and requirements are saved. Open the pack
                        to review these requirements and add any missing
                        documents.
                    </p>
                    <ul class="mb-0 mt-2 list-disc pl-5 text-body-md">
                        @for (
                            requirement of requirements;
                            track requirement.id
                        ) {
                            <li>
                                {{ requirement.sectionName }} ·
                                {{ requirement.name }}
                            </li>
                        }
                    </ul>
                </div>
            </div>
        }
        <div>
            <button
                qpxButton
                matButton="filled"
                context="primary"
                (click)="openPack(current.pack.buildingId, current.pack.id)"
            >
                <span>Open pack</span
                ><ng-icon qpx name="lucideArrowRight" matButtonIcon />
            </button>
        </div>
    </div>
}
@if (error()) {
    <p
        role="alert"
        class="mx-4 mb-4 rounded-lg bg-destructive-muted p-3 text-body-md text-destructive-muted"
    >
        {{ error() }}
    </p>
}
